import { createIcon } from '../createIcon.tsx';

export const DrainIcon = createIcon(
	'DrainIcon',
	<>
		<rect x="3" y="6" width="18" height="12" rx="2" />
		<line x1="6" y1="10" x2="18" y2="10" />
		<line x1="6" y1="14" x2="18" y2="14" />
		<line x1="9" y1="6" x2="9" y2="18" />
		<line x1="15" y1="6" x2="15" y2="18" />
	</>,
);
